<template>
    <ModalConfirm
        id="modal-confirm-export-laporan-kas-kecil"
        title="Konfirmasi Export Laporan"
        desc="Apakah Anda yakin ingin export laporan kas kecil ini?"
        :isSubmitting="isSubmitting"
        @submit="$emit('submit')"
    />
</template>

<script>
export default {
    name: "modal-kas-kecil-export-laporan-confirm",
    props: {
        isSubmitting: { type: Boolean, default: false },
    },
}
</script>
